import { Box, Link, Stack, Typography } from '@mui/material';
import { FormFields, LoginButton } from '../components';
import { FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useLoginForm, useSendLoginMutation } from '../hooks';
import { removeAuthToken } from '@/features/auth/utils';

export const Login = () => {
  const form = useLoginForm();
  const navigate = useNavigate();
  const loginMutation = useSendLoginMutation();

  const handleSubmit = form.handleSubmit((formData) => {
    removeAuthToken();
    loginMutation.mutate(formData);
  });

  return (
    <FormProvider {...form}>
      <Stack
        component="form"
        width={'330px'}
        spacing={2}
        sx={{
          mt: 9,
        }}
        onSubmit={handleSubmit}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          align="center"
          gutterBottom
          sx={{ color: '#33408e' }}
        >
          Admin Login
        </Typography>
        <Typography
          variant="body1"
          align="center"
          mb={3}
          sx={{ color: '#4c4c4c' }}
        >
          Login and manage your app
        </Typography>

        <FormFields />

        <Box mt={3} mb={3} textAlign="center">
          <Link
            underline="hover"
            fontSize={13}
            sx={{ color: '#4c4c4c !important' }}
            onClick={() => navigate('/forgot-password')}
          >
            Forgot password?
          </Link>
        </Box>
        <Box display="flex" justifyContent="center">
          <LoginButton
            type="submit"
            fullWidth
            disabled={loginMutation.isPending}
          >
            Log in
          </LoginButton>
        </Box>
      </Stack>
    </FormProvider>
  );
};
